<!-- eslint-disable vue/valid-template-root -->
<!-- eslint-disable vue/no-empty-component-block -->
<template />

<script>

/**
 * Vue: PDP geo messaging (pdp-geo-messaging)
 * -----------------------------------------------------------------------------
 * Renderless section that handles data collection for various messages
 * displayed on PDP that are tied to geolocation. This section must be added
 * to every product template.
 * - Static section.
 * - Renderless.
 *
 * @param {Object} geoMessaging - Object containing data for displaying at
 * various geo messaging UI elements.
 */
import { mapActions } from 'vuex'

export default {
  name: 'PdpGeoMessaging',

  props: {
    geoMessaging: {
      type: Object,
      default: () => ({}),
    },
  },

  mounted() {
    this.setMessaging(this.geoMessaging)
    this.queryGeolocation()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setGeolocation: 'multi-store/setGeolocation',
      setModalState: 'multi-store/setState',
      setLocalization: 'multi-store/setLocalization',
      setMessaging: 'multi-store/setMessaging',
    }),

    /**
     * Query geolocation from Shopify geolocation app.
     */
    async queryGeolocation() {

      try {
        let response = await fetch('/browsing_context_suggestions.json')
        response = await response.json()

        this.setGeolocation({
          ...response,
        })

      } catch (error) {
        throw new Error('Failed to fetch geolocation', error)
      }
    },
  },
}
</script>

<style lang="scss">
@import './pdp-geo-messaging';
</style>
